import React, { useEffect, useRef, useState } from 'react';

import ReactDOM from 'react-dom';
import { useSelector } from 'react-redux';

import { useDevice } from '@bonnet/next/device';

import { useFeatures } from '@atc/features';
import { ClientOnly } from '@atc/react-client-only';

import { OwnerChat } from 'reaxl-molecules';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

// keeps OwnerChat mounted after popover close due to a limmitation with ActivEngage
export default function useShoppingAssistantOwnerChat(handleSellerChatClick) {
    const {
        chat: [isChatEnabled, { providers: chatProviders, enable_mobile_chat: isMobileChatEnabled }],
    } = useFeatures(['chat']);

    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);
    const {
        owner = {},
        id: listingId,
    } = listing || {};
    const { chat = {}, id: ownerId } = owner;

    const device = useDevice();
    const isXs = device?.is?.xs;

    const chatProvider = chat?.provider;
    const showChatCta = !!(isChatEnabled && (!isXs || isMobileChatEnabled) && !!chat?.provider && chatProviders?.includes(chatProvider));

    const chatWithSellerRef = useRef(null);
    const [chatWithSellerPortalTarget, setChatWithSellerPortalTarget] = useState(null);

    // Create a persistent portal target that survives popover open/close cycles
    useEffect(() => {
        if (showChatCta && !chatWithSellerPortalTarget) {
            const portalTarget = document.createElement('div');
            portalTarget.id = 'chat-seller-portal-target';
            portalTarget.setAttribute('data-cmp', 'chat-seller-portal-target');
            setChatWithSellerPortalTarget(portalTarget);
        }

        return () => {
            if (chatWithSellerPortalTarget && chatWithSellerPortalTarget.parentNode) {
                chatWithSellerPortalTarget.parentNode.removeChild(chatWithSellerPortalTarget);
            }
        };
    }, [showChatCta, chatWithSellerPortalTarget]);

    const chatWithSellerCtaContainer = showChatCta && (
        <div
            ref={(element) => {
                chatWithSellerRef.current = element;
                if (element && chatWithSellerPortalTarget) {
                    if (chatWithSellerPortalTarget.parentNode) {
                        chatWithSellerPortalTarget.parentNode.removeChild(chatWithSellerPortalTarget);
                    }
                    element.appendChild(chatWithSellerPortalTarget);
                }
            }}
        />
    );

    const chatWithSellerLabel = 'Chat with seller';
    const ownerChatAnalyticsData = {
        inventoryId: listingId,
        ownerId,
        placement: 'shopasst',
    };

    const chatWithSellerCta = showChatCta && chatWithSellerPortalTarget && (
        ReactDOM.createPortal(
            <ClientOnly>
                <OwnerChat
                    {...chat}
                    analyticsData={ownerChatAnalyticsData}
                    listing={listing}
                    merchantId={owner.id}
                    uiContext="chip"
                    label={chatWithSellerLabel}
                    chatClickHandler={handleSellerChatClick}
                    forceChatLaunch
                />
            </ClientOnly>,
            chatWithSellerPortalTarget
        )
    );

    return { chatWithSellerCta, chatWithSellerCtaContainer };
}
